module.exports = __webpack_public_path__ + "img/euro.2fac014c.svg";